export default "__VITE_ASSET__dc1f993b__"